module.exports = __webpack_public_path__ + "jordan.svg?2198eac0103c8cb41e13d66b79311ae4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/jordan.svg
// module id = 202
// module chunks = 10